/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Chat_UnavailableInputs */

const en_us2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see the chat.`)
};

const pt_br2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver a conversa.`)
};

const es_419_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para ver el chat.`)
};

const pt_pt2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liga-te à internet para ver a conversa.`)
};

const fr_fr2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte-toi à Internet pour voir la discussion.`)
};

const de_de2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dich mit dem Internet, um den Chat zu sehen.`)
};

const it_it2_clubs_chat_unavailable = /** @type {(inputs: Clubs_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettiti a internet per vedere la chat.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to see the chat." |
*
* @param {Clubs_Chat_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat_unavailable = /** @type {((inputs?: Clubs_Chat_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Chat_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat_unavailable(inputs)
	if (locale === "es-419") return es_419_clubs_chat_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat_unavailable(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat_unavailable(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat_unavailable(inputs)
	return en_us2_clubs_chat_unavailable(inputs)
});
export { clubs_chat_unavailable as "clubs.chat_unavailable" }